<!-- <waitLoading *ngIf="!isLoaded()"></waitLoading> -->
<ng-container *ngIf="isLoaded()">
  <h3>{{ 'Envelope.title' | translate }}</h3>
  <p-table [value]="data" sortField="order" [responsive]="true" [reorderableColumns]="true"
    (onRowReorder)="orderEnvelopes($event)">
    <ng-template pTemplate="header">
      <tr>
        <th [style.width]="'3%'"></th>
        <th [style.width]="'3%'"></th>
        <th [style.width]="'30%'">{{ colHeaders[0] | translate }}</th>
        <th [style.width]="'20%'">{{ colHeaders[1] | translate }}</th>
        <th [style.width]="'25%'" *ngIf="projectHaveLots"> {{ colHeaders[2] | translate }} </th>
        <th [style.width]="'12%'">{{ colHeaders[3] | translate }}</th>
        <th [style.width]="'10%'">{{ colHeaders[4] | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
      <tr [pReorderableRow]="rowIndex">
        <td>
          <i class="fas fa-lg fa-sort" pReorderableRowHandle title="{{ 'Envelope.envelopes.order' | translate }}"></i>
        </td>
        <td>
          <ng-container *ngIf="!assignedToPhase(data)">
            <a (click)="showNotAssignetToPhase()">
              <i class="fas fa-lg fa-exclamation-circle text-warning"
                pTooltip="{{'TenderDefinition.click2ShowErrors' | translate}}" tooltipPosition="right"></i>
            </a>
          </ng-container>
          <ng-container *ngIf="assignedToPhase(data)">
            <ng-container *ngIf="validations && validations.get(data.identifier)?.result === LOADINGRESULT_TYPE">
              <i class="fa fa-spinner loading-spin" aria-hidden="true"
                pTooltip="{{'TenderDefinition.click2ShowErrors' | translate}}" tooltipPosition="right"></i>
            </ng-container>
            <ng-container
              *ngIf="validations && validations.get(data.identifier)?.result && validations?.get(data.identifier)?.result !== 'OK'">
              <a (click)="showValidationResultById(data.identifier)">
                <i class="fas fa-lg fa-exclamation-circle text-warning"
                  pTooltip="{{'TenderDefinition.click2ShowErrors' | translate}}" tooltipPosition="right"></i>
              </a>
            </ng-container>
          </ng-container>
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[0] | translate }}</span> {{ data.description }}
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[1] | translate }}</span> {{ data.type.description }}
        </td>
        <td *ngIf="projectHaveLots">
          <span class="p-column-title">{{ colHeaders[2] | translate }}</span> {{ this.getLots(data) }}
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[3] | translate }}</span> {{ this.getStateDescriptionEnvelope(data)
          }}
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[4] | translate }}</span>
          <div class="btn-group">
            <button class="btn btn-sm btn-secondary t-action-button" aria-expanded="false" (click)="this.editData(data)"
              appNoDblClick title="{{ 'General.edit' | translate}}">
              <i class="fas fa-pencil-alt" aria-hidden="true"></i>
            </button>
            <button class="btn btn-sm btn-secondary t-action-button"
              [attr.disabled]="!canDelete(data) ? 'disabled' : null" aria-expanded="false"
              (click)="this.deleteData(data)" appNoDblClick title="{{ 'General.delete' | translate}}">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="text-center">
        <td colspan="7">{{ 'General.noData' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
  <div class="flex-row py-2">
    <div class="d-flex flex-row-reverse">
      <button class="btn btn-sm btn-outline-primary float-right" (click)="this.newData()" appNoDblClick
        title="{{ 'General.add' | translate }}">
        <i class="fas fa-plus"></i> {{ 'General.add' | translate }} </button>
    </div>
  </div>
</ng-container>
<p-dialog header="{{'General.warning' | translate" [resizable]="true" [(visible)]="showValidationInfo" [closable]="true"
  [responsive]="true" [dismissableMask]="true" [closeOnEscape]="true" [modal]="true" [appendTo]="'body'"
  header="{{ 'Communications.audit.errorsTitle' | translate }}" (onHide)="closeValidationResult()">
  <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
    <div class="container-fluid">
      <div class="row">
        <validationResultMessages [validationresult]="this.validationResult"></validationResultMessages>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>